import React, { Component, Fragment } from 'react'
import { TagLocationCategoriesService } from './services';
import { HttpResponse } from '../../../../core';
import { NavLink } from "react-router-dom";
import { TagLocationCategoriesTabs } from './TagLocationCategoriesTabs'
import { DropdownItemModel } from '../../../../shared/models';
import { ButtonType } from '../../../../shared/enums/button.enum';
import { ShowSuccessMessage, HandleNotFoundResponse } from '../../../../shared/helpers';
import { NotFoundResponseArea } from '../../../../shared/enums';
import { TagLocationCategoriesDeleteModel, TagLocationCategoriesDeleteResponseModel } from './models';

interface IState {
    result?: TagLocationCategoriesDeleteModel;
    deleteResult?: TagLocationCategoriesDeleteResponseModel;
    isDoubleleClick?: boolean;
}
export class DeleteTagLocationCategories extends Component<any, IState> {
    private service: TagLocationCategoriesService;
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.service = new TagLocationCategoriesService();
        this.deleteRecord = this.deleteRecord.bind(this);
    }

    initialState: Partial<IState> = {
        result: {
            id: 0,
            name: "",
            tag_locations: []            
        },
        deleteResult: { isdeleted: false },
        isDoubleleClick: false
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        this.service.getLinkedResourcesById(this.props.match.params.id)
            .then((res: HttpResponse<TagLocationCategoriesDeleteModel>) => {
                if (res && res.result) {
                    this.setState({
                        result: res.result
                    });
                }
            })
            .catch(ex => {
                HandleNotFoundResponse(ex,NotFoundResponseArea.TagLocationCategory,this.props) 
            });
    }

    deleteRecord() {
        if (!this.state.isDoubleleClick) {
            this.setState({ isDoubleleClick: true })
            this.service.deleteRecordById(this.props.match.params.id)
                .then((res: HttpResponse<TagLocationCategoriesDeleteResponseModel>) => {
                    if (res && res.result) {                       
                        this.setState({
                            deleteResult: res.result
                        }, () => {
                            if (this.state.deleteResult?.isdeleted) {
                                ShowSuccessMessage("Tag Location Category Successfully deleted.");
                                this.props.history.push('/tag-location-category/list');
                            }
                        });
                    }
                });
        }
    }

    render() {
        return (
            <Fragment>
                {/* {this.state.result?.scheduled_reports.value == this.props.match.params.id && <div> */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5>Delete  Tag Location Category '{this.state.result?.name}'</h5>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <TagLocationCategoriesTabs id={this.props.match.params.id} url="/tag-location-category/delete/" />
                                <div className="alert font-weight-bold  alert-light"> <i className="fas fa-exclamation-circle text1"></i> Are you sure you want to delete this tag location category <strong>“{this.state.result?.name}”</strong> ?</div>
                                <p className="mt-4 text-danger"><i className="fas fa-exclamation-triangle text1"></i> The following related items may be deleted or orphaned:</p>
                                <div className="row">
                                    <div className="col">
                                        <div className="card card-primary shadow-sm">
                                            <div className="card-header">
                                                <h4>Tag Location Category</h4>
                                            </div>
                                            <div className="card-body">
                                                <NavLink className="badge badge-light text-link" to={"/tag-location-category/detail/" + this.state.result?.id}>{this.state.result?.name} </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.result?.tag_locations && <div className="col">
                                       
                                                <div className="card card-info shadow-sm">
                                                    <div className="card-header"><h4>Tag Locations </h4> </div>

                                                    {this.state.result?.tag_locations && <div className="card-body">
                                                    {this.state.result?.tag_locations.map((item: DropdownItemModel, index) => {
                                                        return (
                                                            <span key={item.id}>
                                                                {item && <NavLink to={"/tag-location/detail/" + item.id} className="badge badge-light m-1"><strong>{index + 1}:</strong> TagLocations #{item.id}</NavLink>}
                                                            </span>
                                                        );
                                                    })}
                                                </div>}
                                                </div>
                                            
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="mx-auto">
                                <button className="btn btn-lg btn-danger" disabled={this.state.isDoubleleClick} onClick={this.deleteRecord}> {ButtonType.Delete}</button>
                                <NavLink type="button" className="btn btn-lg btn-default ml-3" to="/tag-location-category/list">{ButtonType.Cancel}</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div>} */}
            </Fragment>
        )
    }
}
